import React, { useState } from 'react'
import LoadingAnimation from '../../components/LoadingAnimation'

import Modal from '../../components/Modal'

import { getMeterIcon } from "../Dashboard"
import MeterSettings from './MeterSettingsModal'

import { savePdashMeter, METER_TEMPLATES } from '../../prodect/ProsConnect'
import BasicButton from "../../components/BasicButton";

export default function CreateMeterModal(props) {
    const [selectedTemplate, setSelectedTemplate] = useState()
    const [isLoading, setIsLoading] = useState(false)

    async function createMeter(template) {
        setIsLoading(true)
        await savePdashMeter(props.projectId, template)
        setIsLoading(false)
        props.onClose()
    }

    function renderTemplateSelectModal() {
        const templates = METER_TEMPLATES.map(template => {
            const imgSrc = getMeterIcon(template.obj_type)
            return <div key={template.obj_type} className="box element-set-v">
                <div>
                    <img src={imgSrc} alt={template.obj_type} />
                </div>
                <BasicButton
                    btnClass={"primary"}
                    label={template.text}
                    icon={"plus"}
                    action={() => setSelectedTemplate(template)}
                />
            </div>
        })

        return (
            <Modal header="Luo kuvaaja" onClose={() => props.onClose()} showCloseButton>
                <section className="grid-container grid-1 grid-2_md">
                    {templates}
                </section>
            </Modal>
        )
    }

    function renderConfigureMeterModal() {
        return (
            <MeterSettings
                project_settings={props.project_settings}
                meterSettings={{ ...selectedTemplate }}
                meterType={selectedTemplate.obj_type}
                onSave={settings => createMeter(settings)}
                onClose={() => setSelectedTemplate(null)}
                creation={true}
            />
        )
    }

    if (isLoading) {
        return <Modal header="Luodaan kuvaajaa..."><LoadingAnimation /></Modal>
    }

    return selectedTemplate
        ? renderConfigureMeterModal()
        : renderTemplateSelectModal()
}